export default __webpack_public_path__ + "static/media/search.25c89dd9.svg";